import { graphql } from "@apollo/client/react/hoc"
import compose from "lodash/flowRight"
import { UpdatePathItemDocument } from "../../api/generated"
// import { withCohortSyncPlanContext } from "../sync/SyncPlanContext"

export default compose(
  // withCohortSyncPlanContext,
  graphql(UpdatePathItemDocument, {
    options: ({ refetchSyncPlanQueries }) => ({
      // HACK: Apollo bug? This does refetch the sync plan queries but DOES NOT cause the SyncButton to update
      // unclear as to why, but the query data in the SyncButton is stale
      // Maybe related: https://github.com/apollographql/apollo-client/issues/3909
      // appears that below works because the useSyncPlanContext is higher up in the tree, above the SyncButton
      // onCompleted: () => refetchSyncPlanQueries()
      onCompleted: () =>
        window.App &&
        window.App.getStore("pathAdmin").storeTrigger("path:item:updated")
    }),
    props: ({ mutate }) => ({
      updatePathItem: (args) => {
        const keys = [
          "name",
          "description",
          "assignment_type",
          "is_required",
          "allow_resets",
          "show_grading_feedback",
          "completion_comment_required_status",
          "points",
          "minimum_passing_score",
          "grading_type",
          "is_previewable",
          "lock_password",
          "time_to_complete",
          "requires_api_completion"
        ]

        const data = keys.reduce((data, key) => {
          if (typeof args[key] !== "undefined") {
            data[key] = args[key]
          }
          return data
        }, {})

        return mutate({
          variables: {
            path_id: args.path_id,
            source_id: args.source_id,
            type: args.type,
            order: args.order,
            ...data
          }
        })
      }
    })
  })
)
